import React, { useState, useRef, useEffect, Fragment } from "react";
import {
  Card,
  CardBody,
  Modal,
  Label,
  Input,
} from "reactstrap";
import { patiantSuggestionService, uploadInvoiceService, } from "./services/search-patient";
import { toast } from "react-toastify";
import { InputGroup } from "react-bootstrap";
import { FiPhoneCall } from "react-icons/fi";
import { TfiEmail } from "react-icons/tfi";
import { FaLocationDot } from "react-icons/fa6";
import moment from "moment";
import errorProfile from "../.././assets/images/blank_profile.png";
import S3ImageLoader from "../../S3ImageLoader";
import { Breadcrumbs } from "../../AbstractElements";
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import AddPatient from "./AddPatient";
import { useTranslation } from "react-i18next";
import PatientTest from "./PatientTest";
import { useLoader } from "../../_helper/LoaderContext";
import { getPatients, getPatientsHospital } from "../InvestigationReport/services/report-service";
import WalkinPatinet from "./WalkinPatinet";
import { useLab } from "../../_helper/PharmacyProvider";
import SearchPatientModel from "./SearchPatientModal";
import SuggestionTable from "./SuggestionTable";
import { useLocation, useNavigate } from "react-router";
const imageBaseURL = process.env.REACT_APP_BASE_URL;
const DASHBOARD_PREFILL_KEY = "dashboardSuggestionPrefill";

const readDashboardPrefill = (locationState) => {
  if (locationState?.fromDashboardSuggestion) {
    return locationState;
  }
  try {
    const raw = sessionStorage.getItem(DASHBOARD_PREFILL_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.fromDashboardSuggestion ? parsed : null;
  } catch (error) {
    console.error("Unable to read dashboard suggestion prefill:", error);
    return null;
  }
};

const clearDashboardPrefill = () => {
  try {
    sessionStorage.removeItem(DASHBOARD_PREFILL_KEY);
  } catch (error) {
    // ignore
  }
};

const SearchPatient = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dashboardPrefill = readDashboardPrefill(location.state);

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [UploadModelOpen, setUploadModelOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [suggestions, setSuggestions] = useState(
    dashboardPrefill?.suggestions || []
  );
  const [invoices, setInvoices] = useState([]);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [reportUploading, setReportUploading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [searchQuery, setSearchQuery] = useState("");
  const [isPatientModal, setIsPatientModal] = useState(false);
  const { t } = useTranslation()
  const fileInputRef = useRef(null);
  const [customerType, setCustomerType] = useState(
    dashboardPrefill?.fromDashboardSuggestion
      ? "hospitalClinic"
      : "walking"
  );
  const [searchPatients, setSearchPatients] = useState([]);
  const { setLoading } = useLoader()
  const [display, setDisplay] = useState(false)
  const searchInputRef = useRef(null);
  const { currentLab } = useLab();
  const [searchClinicPat, setSearchClinicPat] = useState("");
  const skipSuggestionFetchRef = useRef(!!dashboardPrefill?.suggestions?.length);
  const dashboardPrefillRef = useRef(dashboardPrefill);
  const dashboardResolveDoneRef = useRef(false);
  const dashboardFlowLockRef = useRef(!!dashboardPrefill?.fromDashboardSuggestion);

  // Keep Hospital selected while resolving dashboard patient
  useEffect(() => {
    if (dashboardPrefillRef.current?.fromDashboardSuggestion) {
      dashboardFlowLockRef.current = true;
      setCustomerType("hospitalClinic");
    }
  }, []);

  // From Dashboard: Hospital selected → fetch lab-patient/master → auto-select patient by ID
  useEffect(() => {
    const prefill = dashboardPrefillRef.current || readDashboardPrefill(location.state);
    if (!prefill?.fromDashboardSuggestion || dashboardResolveDoneRef.current) return;
    if (!currentLab?.hospital_id) return;

    dashboardResolveDoneRef.current = true;
    dashboardPrefillRef.current = prefill;
    dashboardFlowLockRef.current = true;
    setCustomerType("hospitalClinic");

    const resolveHospitalPatient = async () => {
      const searchValue = (prefill.patientSearch || prefill.healthId || prefill.hospitalPatientId || "").trim();
      if (!searchValue) {
        toast.error(t("Patient details are incomplete"));
        clearDashboardPrefill();
        dashboardFlowLockRef.current = false;
        return;
      }

      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("search", searchValue);
        formData.append("clinic_id", currentLab.hospital_id);

        const response = await getPatientsHospital(formData);
        const patients = response?.data?.data?.patients || [];

        const patientId = prefill.hospitalPatientId
          ? String(prefill.hospitalPatientId)
          : null;
        const healthId = (prefill.healthId || "")
          .replace(/\s/g, "")
          .toLowerCase();

        const matched =
          patients.find(
            (p) => patientId && String(p._id) === patientId
          ) ||
          patients.find((p) => {
            const pHealth = String(p.uniqueId || p.health_id || "")
              .replace(/\s/g, "")
              .toLowerCase();
            return healthId && pHealth === healthId;
          }) ||
          null;

        if (!matched) {
          toast.error(t("Patient not found"));
          clearDashboardPrefill();
          dashboardFlowLockRef.current = false;
          return;
        }

        if (prefill.suggestions?.length) {
          skipSuggestionFetchRef.current = true;
          setSuggestions(prefill.suggestions);
        }

        setCustomerType("hospitalClinic");
        setSelectedPatient(matched);
        clearDashboardPrefill();
        // Absorb delayed radio-group onChange that flips back to Existing
        setTimeout(() => {
          dashboardFlowLockRef.current = false;
        }, 1000);
      } catch (error) {
        console.error("Error fetching hospital patient:", error);
        toast.error(t("Unable to load patient details"));
        clearDashboardPrefill();
        dashboardFlowLockRef.current = false;
      } finally {
        setLoading(false);
      }
    };

    resolveHospitalPatient();
  }, [currentLab?.hospital_id]);

  useEffect(() => {
    if (selectedPatient) {
      if (skipSuggestionFetchRef.current) {
        skipSuggestionFetchRef.current = false;
        return;
      }
      setSuggestions([]);
      getData();
    } else if (!dashboardPrefillRef.current) {
      setSuggestions([]);
    }
  }, [selectedPatient]);

  const getData = async () => {
    setInvoicesLoading(true);

    if (customerType === "hospitalClinic") {
      setSuggestionsLoading(true);
      const suggestionForm = {
        patient_id: selectedPatient._id,
        pageNo: 1,
        pageSize: 10,
        clinic_id: currentLab.hospital_id
      };

      try {
        const suggestion = await patiantSuggestionService(suggestionForm);
        setSuggestions(suggestion.data?.data?.suggestions || []);
      } catch (error) {
        console.error("Error fetching patient data:", error);
        setSuggestions([]);
      } finally {
        setSuggestionsLoading(false);
        setInvoicesLoading(false);
      }
    } else {
      setSuggestions([]);
      setSuggestionsLoading(false);
      setInvoicesLoading(false);
    }
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const toggleUploadModel = () => setUploadModelOpen(!UploadModelOpen);

  const handleUploadSubmit = async () => {
    let formErrors = {};
    if (!file) formErrors.file = "Please select a file.";
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    const formData = new FormData();
    formData.append("patient_id", selectedPatient._id);
    formData.append("document", file);

    setReportUploading(true);
    try {
      const res = await uploadInvoiceService(formData);
      if (res.data.status === "success") {
        toast.success("Report Uploaded Successfully");
        setErrors({});
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        setUploadModelOpen(false);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.error("Error while uploading report", error);
    } finally {
      setReportUploading(false);
    }
  };

  const handleSearchClick = () => {
    if (searchQuery.trim().length >= 3) {
      // setIsPatientModal(true);
    } else {
      toast.warning("Please enter at least 3 characters to search");
    }
  };

  const handleSearchKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearchClick();
    }
  };

  const calculateAge = (birthDate) => {
    const birthDateMoment = moment(birthDate);
    const currentDate = moment();
    const age = currentDate.diff(birthDateMoment, "years");
    return age;
  };

  const handleCustomerTypeChange = (e) => {
    const value = e.target.value;
    // Ignore browser radio-group fallback to Existing while Hospital is loading from Dashboard
    if (dashboardFlowLockRef.current && value !== "hospitalClinic") {
      setCustomerType("hospitalClinic");
      return;
    }
    setCustomerType(value);
    setSelectedPatient(null);
    setSearchQuery("");
    setSearchPatients([]);
    setSearchClinicPat("");
    setSuggestions([]);
    setIsPatientModal(false);
    if (value === "hospital") {
      setDisplay(true);
    }
  };

  useEffect(() => {
    if (customerType === "walking") {
      if (searchQuery.length >= 3) {
        getPatientsList(searchQuery);
      } else {
        setSearchPatients([]);
      }
    }
  }, [searchQuery, customerType]);

  useEffect(() => {
    // Do not force Existing when coming from Dashboard Hospital suggestion
    if (dashboardPrefillRef.current?.fromDashboardSuggestion) return;

    if (customerType === "walking" && !selectedPatient) {
      const timer = setTimeout(() => {
        searchInputRef.current?.focus();
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [customerType, selectedPatient]);

  // Also try on mount
  useEffect(() => {
    if (dashboardPrefillRef.current?.fromDashboardSuggestion) return;

    const timer = setTimeout(() => {
      if (customerType === "walking" && searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  const getPatientsList = async (searchValue) => {
    try {
      setLoading(true);
      const form_data = new FormData();
      form_data.append("search", searchValue);
      if (customerType === "hospitalClinic" && currentLab?.hospital_id) {
        form_data.append("clinic_id", currentLab.hospital_id);
      }
      const response = await getPatients(form_data);
      if (response.data.success == true) {
        setSearchPatients(response.data.data.patients || []);
      } else {
        setSearchPatients([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setSearchPatients([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectPatient = (data) => {
    setSelectedPatient(data);
    setSearchQuery("");
    setSearchClinicPat("");
    setSearchPatients([]);
    setIsPatientModal(false);
  };

  const handleNewPatientCreated = (newPatient) => {
    setSelectedPatient(newPatient);
    setCustomerType("hospital");
    setUploadModelOpen(false);
    setDisplay(false);
  };

  // hospital customer — open modal with patient list
  const handleSearchClickClinic = () => {
    if (searchClinicPat.trim().length >= 3) {
      setIsPatientModal(true);
    } else {
      toast.warning("Please enter at least 3 characters to search");
    }
  };

  const handleSearchKeyPressClinic = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearchClickClinic();
    }
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle="New Test" parent="Home" title="New Test" />
      <Container fluid={true}>
        <Row>
          <Col className="h-100">
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody className="px-3">
                    <div className="row g-3 align-items-center">

                      {/* Customer Type: Walking / Hospital */}
                      <div className="col-md-6">
                        <div className="d-flex align-items-center gap-3">
                          <span className="fw-medium text-nowrap">Customer :</span>
                          <div className="radio radio-primary">
                            <Input
                              id="customer-radio-walking"
                              type="radio"
                              name="customerType"
                              value="walking"
                              checked={customerType === "walking"}
                              onChange={handleCustomerTypeChange}
                            />
                            <Label for="customer-radio-walking" className="mb-0 pe-2">
                              {t("Existing")}
                            </Label>
                          </div>

                          <div className="radio radio-primary">
                            <Input
                              id="customer-radio-hospital"
                              type="radio"
                              name="customerType"
                              value="hospital"
                              checked={customerType === "hospital"}
                              onChange={handleCustomerTypeChange}
                            />
                            <Label for="customer-radio-hospital" className="mb-0 pe-2">
                              {t("Walk-In")}
                            </Label>
                          </div>
                          {(currentLab?.isHospitalConnected == true ||
                            customerType === "hospitalClinic") && (
                            <div className="radio radio-primary">
                              <Input
                                id="customer-radio-hospital1"
                                type="radio"
                                name="customerType"
                                value="hospitalClinic"
                                checked={customerType === "hospitalClinic"}
                                onChange={handleCustomerTypeChange}
                              />
                              <Label for="customer-radio-hospital1" className="mb-0 pe-2">
                                {t("Hospital")}
                              </Label>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Search Bar */}
                      {customerType === "walking" && (
                        <div className="col-md-6" style={{ position: "relative" }}>
                          <div className="tw-relative tw-w-full md:tw-w-full">
                            <input
                              type="text"
                              ref={searchInputRef}
                              className="form-control"
                              placeholder="Search Customer by Name"
                              value={searchQuery}
                              onChange={(e) => setSearchQuery(e.target.value)}
                              autoComplete="off"
                            />

                            {/* Dropdown Results */}
                            {searchQuery.length >= 3 && (
                              <div
                                className="tw-absolute tw-left-0 tw-top-full tw-z-[999]
                 tw-mt-1 tw-w-full
                 tw-rounded-md tw-border tw-border-[#006E27]
                 tw-bg-white tw-shadow-lg
                 tw-max-h-60 tw-overflow-y-auto"
                              >
                                {searchPatients.length > 0 ? (
                                  searchPatients.map((p, index) => (
                                    <div
                                      key={index}
                                      onMouseDown={() => handleSelectPatient(p)}
                                      className="tw-cursor-pointer tw-px-3 tw-py-2 tw-text-sm tw-font-medium
                       tw-border-b tw-border-gray-200
                       hover:tw-bg-green-50 last:tw-border-b-0"
                                    >
                                      {p.fname} {p.lname || ""} — {p.contact}
                                    </div>
                                  ))
                                ) : (
                                  <div className="tw-px-3 tw-py-2 tw-text-sm tw-text-gray-500">
                                    No customer found
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                        </div>
                      )}

                      {customerType === "hospitalClinic" && (
                        <div className="col-md-6">
                          <div className="tw-flex-1">
                            <InputGroup className="custom-input-group">
                              <Input
                                type="search"
                                className="search-bar patient-search-bar tw-rounded-s-full"
                                placeholder="Search Customer by CLINICDOTS ID / Name / Email / Phone"
                                value={searchClinicPat}
                                onChange={(e) => setSearchClinicPat(e.target.value)}
                                onKeyPress={handleSearchKeyPressClinic}
                              />
                              <InputGroup.Text
                                onClick={handleSearchClickClinic}
                                className="text-white patient-search-icon-btn tw-rounded-e-full"
                                style={{
                                  backgroundColor: "var(--theme-default)",
                                  background:
                                    "linear-gradient(180.05deg, #2B3A8F 20.14%, #1B255B 87.13%)",
                                }}
                              >
                                <i
                                  className="fa fa-search"
                                  style={{ fontSize: "14px", height: "22px", width: "16px" }}
                                ></i>
                              </InputGroup.Text>
                            </InputGroup>
                          </div>
                        </div>
                      )}

                      {/* Add Button */}
                    </div>
                    {display === true && (
                      customerType === "hospital" && (
                        <div className="mt-3">
                          <WalkinPatinet getData={getData}
                            onPatientCreated={handleNewPatientCreated} />
                        </div>
                      )
                    )}

                    {selectedPatient && (
                      <>
                        <div className="mt-4">
                          <Card style={{ border: "2px solid #1b255b" }}>
                            <div className="p-2">
                              <div className="p-2 d-flex tw-space-x-2">
                                <S3ImageLoader
                                  fileName={selectedPatient?.profile_picture}
                                  fallbackSrc={errorProfile}
                                  className="patient-pic img-60"
                                  alt="Patient"
                                />
                                <div className="ps-3">
                                  <h6 className="mb-0">
                                    <strong>
                                      {selectedPatient.fname || selectedPatient.full_name}{" "}
                                    </strong>
                                  </h6>
                                  <small
                                    style={{
                                      fontSize: "12px",
                                      textTransform: "capitalize",
                                    }}
                                  >
                                    Gender {selectedPatient.gender},{" "}
                                    {selectedPatient.age && (
                                      <>
                                        Age {selectedPatient.age}
                                      </>
                                    )}
                                  </small>
                                </div>
                                <div className="row ps-3">
                                  {selectedPatient.contact && (
                                    <div className="col-md-6">
                                      <div className="d-flex align-items-center">
                                        <div className="p-0 rounded-circle me-2">
                                          <FiPhoneCall />
                                        </div>
                                        <span style={{ fontSize: "12px" }}>
                                          {selectedPatient.contact}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {selectedPatient.email && (
                                    <div className="col-md-12">
                                      <div className="d-flex align-items-center">
                                        <div className="p-0 rounded-circle me-2">
                                          <TfiEmail />
                                        </div>
                                        <span style={{ fontSize: "12px" }}>
                                          {selectedPatient.email}
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                  {selectedPatient.address && (
                                    <div className="col-md-12">
                                      <div className="d-flex align-items-center">
                                        <div className="p-0 rounded-circle me-2">
                                          <FaLocationDot />
                                        </div>
                                        <small>{selectedPatient.address}</small>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </Card>
                        </div>
                        {customerType == "hospitalClinic" && (
                          <Card className="mt-4">
                            <CardBody className="p-3">
                              {/* <TabContent activeTab={activeTab} className="mt-3">
                              <TabPane tabId="1"> */}
                              <SuggestionTable
                                showText={true}
                                suggestions={suggestions}
                                loading={suggestionsLoading}
                              />
                              {/* </TabPane>
                            </TabContent> */}
                            </CardBody>
                          </Card>
                        )}
                        <PatientTest
                          selectedPatient={selectedPatient}
                          customerType={customerType}
                          suggestions={suggestions}
                        />
                      </>
                    )}
                  </CardBody>
                </Card>

              </div>
            </div>

            <SearchPatientModel
              searchQuery={searchClinicPat}
              setSearchQuery={setSearchClinicPat}
              isPatientModal={isPatientModal}
              setIsPatientModal={setIsPatientModal}
              customerType={customerType}
              handleSelectPatient={handleSelectPatient}
            />
            {/* Upload Report Modal */}
            <Modal isOpen={UploadModelOpen} toggle={toggleUploadModel}>
              <AddPatient toggleUploadModel={toggleUploadModel} setUploadModelOpen={setUploadModelOpen} data={{}} getData={getData}
                onPatientCreated={handleNewPatientCreated}
              />
            </Modal>
          </Col>
        </Row>
      </Container>

    </Fragment >
  );
};

export default SearchPatient;
